export default class LabTest {
  constructor() {
    this.pond_id = "";
    this.lab_id = "";
    this.ph = 0;
    this.salinity = 0;
    this.do = 0;
    this.co3 = 0;
    this.hco3 = 0;
    this.alkallnity_total = 0;
    this.hardness = 0;
    this.ammonia = 0;
    this.iron = 0;
    this.green_colonies = 0;
    this.yellow_colonies = 0;
  }
}
